import { render, staticRenderFns } from "./compCommissionRecord.vue?vue&type=template&id=7002121e"
import script from "./compCommissionRecord.vue?vue&type=script&lang=js"
export * from "./compCommissionRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports